import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';

import {
	withStyles,
	Paper,
	Grid,
	Typography,
	RootRef,
	Divider
} from '@material-ui/core';

import {useScrollTo} from "../../utils/CustomHooks";

const styles = theme => ({
	root: {
		[theme.breakpoints.down('md')]: {
			height: 493,
		} 
	},

	taller: {
		height: 508,

		[theme.breakpoints.down('xs')]: {
			height: 550,
		}
	},

	paper: {
		flex: 1,
		position: "relative",
		overflow: "hidden",
		borderRadius: 16,
		border: `0.5px solid ${theme.palette.primary.lightGrey}`,
	},

	section: {
		padding: "24px",
	},

	middleSection: {
		paddingBottom: 0
	},

	title: {
		fontWeight: 500
	},

	subtitle: {
		marginBottom: theme.spacing(1.5)
	}
});

class ReportItemPaper extends Component {
	constructor(props, context) {
		super(props, context);
		this.paperRef = React.createRef();
		this.scrollToHook = useScrollTo();
	}

	componentDidUpdate(prevProps, prevState) {
		let {scrollTo} = this.props;
		if (prevProps !== this.props && scrollTo) {
			this.scrollToHook(0, scrollTo, this.paperRef.current);
		}
	}

	render() {
		let {classes, fidoError, previousDays, taller, className,
			placeHolder, ready, title, subtitle, children, buttons, id} = this.props;

		return (
			<div
				id={id}
				className={`${classes.root} ${taller ? classes.taller : null}`}>
				<RootRef rootRef={this.paperRef}>
					<Paper className={`${classes.paper} ${className}`}>
						<div className={classes.section}>
							<ReactPlaceholder
								ready={ready}
								showLoadingAnimation={!fidoError}>
								<Grid
									container
									justifyContent={"space-between"}
									alignItems={"baseline"}>
									{title ?
										<Grid item>
											<Typography variant="h2" className={classes.title}>{title}</Typography>
										</Grid> : null
									}
									{/* {previousDays ?
										<Grid item>
											<Typography variant="caption" align="right">Prior {previousDays} Days</Typography>
										</Grid> : null
									} */}
								</Grid>
							</ReactPlaceholder>
						</div>
						<Divider />
						<div className={`${classes.middleSection} ${classes.section}`}>
							<ReactPlaceholder
								ready={ready}
								customPlaceholder={placeHolder}
								showLoadingAnimation={!fidoError}>
								{subtitle ?
									<Typography variant="body1" color="textSecondary" className={classes.subtitle}>{subtitle}</Typography>
								: null}
								{children}
							</ReactPlaceholder>
						</div>
						<div className={classes.section}>
							{buttons}
						</div>
					</Paper>
				</RootRef>
			</div>
		);
	}
}

ReportItemPaper.propTypes = {
	classes: PropTypes.object.isRequired,
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	ready: PropTypes.bool.isRequired,
	fidoError: PropTypes.bool,
	previousDays: PropTypes.number,
	placeHolder: PropTypes.object,
	title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	subtitle: PropTypes.string,
	className: PropTypes.string,
	taller: PropTypes.bool,
	scrollTo: PropTypes.number,
	id: PropTypes.string,
	buttons: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default withStyles(styles)(ReportItemPaper);
